import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=1421460f&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=js&"
export * from "./AddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1421460f",
  null
  
)

export default component.exports